import * as React from 'react';

import FabricAnalyticsListeners, { FabricChannel } from '@atlaskit/analytics-listeners';

import type { AnalyticsClientProps } from './with-analytics-client';

export const withFabricAnalyticsListeners =
  <POwnProps extends {}>(WrappedComponent: React.ComponentType<POwnProps>) =>
  (props: POwnProps & AnalyticsClientProps) => {
    const analyticsClient = props.analyticsClient?.getAnalyticsWebClient?.();

    return (
      <FabricAnalyticsListeners
        client={analyticsClient}
        excludedChannels={[FabricChannel.atlaskit, FabricChannel.elements, FabricChannel.editor, FabricChannel.media]}
      >
        <WrappedComponent {...props} />
      </FabricAnalyticsListeners>
    );
  };
